export enum SUCCESS_MESSAGE {
    FIELDS_UPDATED = "Fields successfully updated",
    FILE_UPLOADED = "File successfully uploaded"
}

export enum ERROR_MESSAGE {
    REGISTER = "Registration failed",
    LOGIN = "Login failed"
}